/**
 * Hook to get configured InvoicesClient instance
 */

import { InvoicesClient } from "@eoln/sdk-invoices";
import { useMemo } from "react";
import { useAuth } from "./useAuth";

const INVOICES_API_URL = import.meta.env.VITE_INVOICES_API_URL || "https://invoices-api.mono-dev.eoln.eu/graphql";

export function useInvoicesClient() {
  const { apiKey } = useAuth();

  return useMemo(() => {
    const client = new InvoicesClient({
      endpoint: INVOICES_API_URL,
    });

    if (apiKey) {
      client.setApiKey(apiKey);
    }

    return client;
  }, [apiKey]);
}
